/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { UserService } from '../../services/user.service';
import { loadUserInfo, loadUserInfoError, loadUserInfoSuccess } from '../actions/user.actions';

@Injectable()
export class UserEffects {
  constructor(private actions$: Actions, public userService: UserService) {}
  loadUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserInfo),
      mergeMap(() =>
        this.userService.info().pipe(
          map((user) => loadUserInfoSuccess({ user })),
          catchError((error) => of(loadUserInfoError({ payload: error })))
        )
      )
    )
  );
}
